import { Badge } from 'antd';
import { FC, HTMLAttributes } from 'react';

import classes from './IssueStatusBadge.module.scss';

export type StatusColor = 'success' | 'processing' | 'warning' | 'error' | 'default';

export interface IssueStatusBadgeProps extends HTMLAttributes<HTMLDivElement> {
  text: string;
  status: StatusColor;
  className?: string;
}

export const IssueStatusBadge: FC<IssueStatusBadgeProps> = ({ text, status, className = '', ...props }) => {
  return (
    <div className={`${classes.statusBadge} ${className}`} {...props}>
      <Badge status={status} />
      <span className={classes.text}>{text}</span>
    </div>
  );
};
